import { Intervention } from '@agroone/entities'
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { DateWeekNumberDirective } from '../../../../directives/date-week-number.directive'
import { TranslateConstantPipe } from '../../../../pipes'
import { SharedConstantService } from '../../../../services'
import { InterventionOperationsTypes } from '../../enums/intervention-operations-types.enum'

@Component({
  selector: 'operation',
  templateUrl: './operation.component.html',
  styleUrls: ['./operation.component.scss'],
  imports: [TranslateConstantPipe, TranslatePipe, DateWeekNumberDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class OperationComponent {
  readonly intervention = input.required<Intervention>()
  public constantService: SharedConstantService = inject(SharedConstantService)
  public translate: TranslateService = inject(TranslateService)
  public interventionOperationsTypes = InterventionOperationsTypes
}
